import styled from "styled-components";
import { space } from "styled-system";
import { themeGet } from "@styled";

export const DropdownWrap = styled.div`
    ${space};
`;

export const DropdownMenu = styled.ul`
    position: relative;
    color: ${themeGet("colors.text")};
`;
